import React, { useState, useRef, useEffect } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP);


const dev = ["LWT", "Material Study", "Rough Animation","Short Film"];

export default function HomePage() {

    const container = React.useRef();

    const svgRef = useRef(null);
    const ease = 0.75;
    const total = 100;

    useEffect(() => {
        const pointer = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        let leader = pointer;

        const createLine = (leader, i) => {
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            svgRef.current.appendChild(line);

            gsap.set(line, { x: -15, y: -15, alpha: (total - i) / total });

            gsap.to(line, {
                duration: 0.2,
                x: 1,
                y: 1,
                repeat: -1,
                modifiers: {
                    x: () => {
                        const posX = gsap.getProperty(line, 'x');
                        const leaderX = gsap.getProperty(leader, 'x');
                        const x = posX + (leaderX - posX) * ease;
                        line.setAttribute('x2', leaderX - x);
                        return x;
                    },
                    y: () => {
                        const posY = gsap.getProperty(line, 'y');
                        const leaderY = gsap.getProperty(leader, 'y');
                        const y = posY + (leaderY - posY) * ease;
                        line.setAttribute('y2', leaderY - y);
                        return y;
                    },
                },
            });

            return line;
        };

        for (let i = 0; i < total; i++) {
            leader = createLine(leader, i);
        }

        window.addEventListener("mousemove", (event) => {
            pointer.x = event.clientX;
            pointer.y = event.clientY;
        });

    }, []);


    useGSAP(() => {
        gsap.set(".flair", { xPercent: -50, yPercent: -50 });
        let targets = gsap.utils.toArray(".flair");

        let xTo = gsap.quickTo(targets, "x", { duration: 0.2, ease: "power3" }),
            yTo = gsap.quickTo(targets, "y", { duration: 0.2, ease: "power3" });


        window.addEventListener("mousemove", (e) => {
            xTo(e.clientX);
            yTo(e.clientY);
        });

    }, {});



    const [toggle, setToggle] = useState(false)
    const [toggle2, setToggle2] = useState(false)

    if (toggle) {
        var clsName = "child1"
        var clsName2 = "child2"
        var clsName3 = "child3"
        var clsName4 = "child4"
        var clsName5 = "child5"
        var clsName6 = "ch-bg"
        var nav_right = "nav-right"
        var bg_ca = "bg_ca"

        if (toggle2) {
            clsName = "chld1"
            clsName2 = "cild2"
            clsName3 = "cild3"
            clsName4 = "chld4"
            clsName5 = "chld5"
        }
    }
    else {
        clsName = "child"
        clsName2 = "chid2"
        clsName3 = "chid3"
        clsName4 = "chid4"
        clsName5 = "chid5"
        clsName6 = "ch-bg3"
        nav_right = "nav_right"
        bg_ca = "ca_bg"
    }

    return (
        <>
            <div className="parent">
                <div className={clsName} onClick={(e) => setToggle(!toggle)}>
                <h1 className="help">Click Anywhere</h1>
                    <div className={nav_right}>
                        <ul className='ul'>
                            <a className="lwt" href="/LetsWorkTogether"><li className="lwt2"></li></a>
                            <a href="/MaterialStudy"><li>{dev[1]}</li></a>
                            <a href="/RoughAnimation"><li>{dev[2]}</li></a>
                            <a href="/ShortFilm"><li>{dev[3]}</li></a>
                        </ul>
                    </div>
                    <div className="sub-child"></div>
                    <img className="name" src="Portfolio Fonts02.png"/>
                    {toggle && (
                        <Profile />
                    )}
                    <span className="flair flair--3"></span>
                    <svg ref={svgRef} width="100%" height="100%"></svg>
                    <video className="shrtfilm" autoPlay loop muted>
                        <source src="mycharacters-vatsalr.j.chourey.mp4" type="video/mp4"></source>
                    </video>
                </div>
                <a className={clsName6} href="/Character-Design">
                    <div className={clsName2}>
                        <img className="cd" src="Portfolio Fonts01.png"/>
                        <div className="sub-child"></div>
                    </div>
                </a>
                <a className={bg_ca} href="/ConceptArt" >
                    <div className={clsName3}>
                        <img className="ca" src="Portfolio Fonts05.png"/>
                    </div>
                </a>
                <a className={clsName4} href="/Backgrounds">
                    <div className="sub-child">
                        <img className="bg" src="Portfolio Fonts03.png"/>
                    </div>
                    <div className="sub-child2"></div>
                    <div className="sub-child3"></div>
                </a>
                <a className={clsName5} href="/illustration" >
                <img className="ill" src="Portfolio Fonts04.png"/>
                </a>
            </div>
        </>
    );

}


function Profile() {
    return (
        <>
            <div className="profile"></div>
        </>
    );
}
